import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
// import UploadExcel  from './UploadExcel'

export const MasterList = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [deletebtnStatus, setDeletebtnStatus] = useState(true);

  const addNewForm = (value) => {
    props.handleOpen(value);
  };

  const upload = (value) => {
    props.uploadData(value);
  };

  useEffect(() => {
    setLoading(true);
    if (props.rowsData) {
      setLoading(false);
    }

    if (props.deleteEnabled === false) {
      setDeletebtnStatus(false);
    } else {
      setDeletebtnStatus(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return (
    <div>
      <Accordion defaultActiveKey="0">
        <Card>
          {props.customCardHeader && (
            <Card.Header>
              <Button
                class="accordion-button"
                type="button"
                variant="primary"
                onClick={(e) => {
                  e.preventDefault();
                  props.handleAckAllJobCards();
                }}
              >
                {t("msg_common.Acknowledge")}
              </Button>
            </Card.Header>
          )}
          {props.cardHeader && (
            <Card.Header>
              <Button
                class="accordion-button"
                type="button"
                variant="primary"
                onClick={() => addNewForm(true)}
              >
                <i className="bi bi-plus"></i> {t("msg_common.add")}
              </Button>
              {deletebtnStatus && (
                <Button
                  class="accordion-button"
                  type="button"
                  variant="danger"
                  onClick={props.handleDelete}
                >
                  <i className="bi bi-trash3"></i>
                  {t("msg_common.delete")}
                </Button>
              )}

              {props.uploadButton && (
                <Button
                  class="accordion-button"
                  type="button"
                  variant="primary"
                  onClick={() => upload(true)}
                >
                  {t("msg_common.upload")}
                </Button>
              )}
              {props.extraButton && (
                <Button
                  class="accordion-button"
                  type="button"
                  variant="secondary"
                  onClick={props.handleBtnClick}
                >
                  {/*{props.btnText} */}
                  View QR Code
                </Button>
              )}
            </Card.Header>
          )}
          <Card.Body>
            <DataTable
              title={props.title}
              columns={props.columnsData}
              data={props.rowsData}
              paginationRowsPerPageOptions={props.paginationRowsPerPageOptions}
              progressPending={loading}
              pagination={props.pagination}
              selectableRows={props.selectableRows}
              handleClose={props.handleClose}
              handleOpen={props.handleOpen}
              onSelectedRowsChange={props.handleRowSelected}
              clearSelectedRows={props.clearSelectedRows}
            />
          </Card.Body>
        </Card>
      </Accordion>
    </div>
  );
};
MasterList.defaultProps = {
  cardHeader: true,
};
export default MasterList;
